// Dependencies
import styled from 'styled-components';

const BlogPostSidebarStyles = styled.aside`
  width: 100%;
  padding: 1.875rem 0;

  .author {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 0 1.25rem 0;

    .top {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .profile-photo {
        width: 3.375rem;
        height: 3.375rem;
        margin: 0 1.125rem 0 0;
        border-radius: 100%;
      }

      .name {
        margin: 0;
        padding: 0;
        font-size: 0.938rem;
        font-style: italic;
        color: var(--color-bark);
      }
    }
  }

  @media (min-width: 768px) {
    width: 30%;
    padding: 1.875rem 2rem 1.875rem 0;

    .author {
      .top {
        width: 100%;

        .profile-photo {
          margin: 0 1.125rem 0.5rem 0;
        }

        .name {
          width: 100%;
          font-size: 1.375rem;
        }
      }
    }

    .separator {
      display: none;
    }
  }

  @media (min-width: 992px) {
    width: 20%;
  }

  @media (min-width: 1200px) {
    padding: 1.875rem 3rem 1.875rem 0;
  }
`;

export default BlogPostSidebarStyles;
